function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

//
import * as React from 'react';
import { color, StyleSheet, css } from "../../styles/theme";
var styles = StyleSheet.create({
  PartnerLogoContainer: {
    position: 'absolute',
    border: "1px solid ".concat(color.borderThemeDark),
    borderRadius: 3,
    zIndex: 1,
    backgroundColor: color.white
  },
  partnerLogo: {
    width: '100%',
    height: '100%',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }
});
export default function PartnerLogo(props) {
  var logoSrc = props.logoSrc;
  return React.createElement("span", _extends({}, css(styles.PartnerLogoContainer), {
    style: props.style
  }), logoSrc && React.createElement("div", _extends({}, css(styles.partnerLogo), {
    style: {
      backgroundImage: "url(".concat(logoSrc, ")")
    }
  })));
}